import { Button, Checkbox } from '@salesforce/design-system-react';
import React, { useState, useContext } from 'react';
import {
  signInWithGoogle,
  login,
  apiMetaMaskNonce,
  apiSignInMetaMask,
  setCurrentUser,
  signIn,
} from '../../services/auth';
import Google_Icon from '../../assets/images/login/google.png';
import QFG_login from '../../assets/images/login/QFG_login.png';
import QFG_login_white from '../../assets/images/login/login_white.png';
import './login.css';
import toast, { Toaster } from 'react-hot-toast';
import { ThemeContext } from '../../context/ThemeContext';
import { Link, useNavigate } from 'react-router-dom';
import Web3 from 'web3';
import { useDispatch } from 'react-redux';
import { setUser } from '../../store/auth/slice';
import * as tokenService from '../../services/token';

const LoginLeft = () => {
  const [email, setEmail] = useState(false);
  const [password, setPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { isDarkTheme } = useContext(ThemeContext);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [passwordVisible, setPasswordVisible] = useState(false);

  const onFormSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      signIn({ email, password })
        .then((resp) => {
          if (resp.status === 'failed') {
            toast.error(resp.message, {
              id: 'failed-login',
            });
          }

          if (resp.status === true) {
            navigate('/');
          }

          setLoading(false);
        })
        .catch((error) => {
          // if (error.message === 'Firebase: Error (auth/missing-email).') {
          //     signup({ email, password });
          //   }
          if (
            error.message === 'Firebase: Error (auth/user-not-found).' ||
            error.message === 'Firebase: Error (auth/wrong-password).'
          ) {
            toast.error(`Email and password didn't match.`, {
              id: 'login-failed',
            });
          } else if (error.message.toLowerCase().includes('auth/too-many-requests')) {
            toast.error(`Too many login requests.`, {
              id: 'login-too-many-requests-error',
            });
          } else if (error.message.toLowerCase().includes('auth/unauthorized-domain')) {
            toast.error(`Can't login on unauthorized domain.`, {
              id: 'login-unauthorized-domain',
            });
          } else {
            toast.error(`Login failed.`, {
              id: 'login-error',
            });
          }
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const loginWithGoogle = (toast) => {
    signInWithGoogle()
      .then((result) => {
        if (result.status === 'failed') {
          toast.error(result.message, {
            id: 'failed-login',
          });
        }

        if (result.status === true) {
          navigate('/');
        }

        setLoading(false);
      })
      .catch((error) => {
        toast.error(error, {
          id: 'login-error-message',
        });
      });
  };

  const detectCurrentProvider = (toast) => {
    let provider;
    if (window.ethereum) {
      provider = window.ethereum;
    } else if (window.web3) {
      // eslint-disable-next-line
      provider = window.web3.currentProvider;
    } else {
      toast.error(`Non-Ethereum browser detected. You should consider trying MetaMask!`, {
        id: 'non-ethereum',
      });
    }
    return provider;
  };

  const onSignInWithMetaMask = async (toast) => {
    try {
      const currentProvider = detectCurrentProvider(toast);
      if (currentProvider) {
        if (currentProvider !== window.ethereum) {
          toast.error(`Non-Ethereum browser detected. You should consider trying MetaMask!`, {
            id: 'non-ethereum',
          });
        }
        await currentProvider.request({ method: 'eth_requestAccounts' });
        const web3 = new Web3(currentProvider);
        const userAccount = await web3.eth.getAccounts();
        const account = userAccount[0];
        getNonceInfo(account);
        if (userAccount.length === 0) {
          toast.loading(`Please connect to meta mask`, {
            id: 'connect-to-metamask',
          });
        }
      }
    } catch (err) {
      toast.error(
        `There was an error fetching your accounts. Make sure your Ethereum client is configured correctly.`,
        {
          id: 'connect-to-metamask-error',
        }
      );
    }
  };

  const getNonceInfo = async (account) => {
    try {
      const result = await apiMetaMaskNonce(account);

      if (result.status === 200) {
        if (result.data.data) {
          const nonce = result.data.data.nonce ?? '';
          nonce
            ? getSignatureFromWeb3(nonce, account)
            : toast.error(`There was an error authenticating. Please try again`, {
                id: 'metamask-error',
              });
        }
      } else {
        toast.error(`There was an error authenticating. Please try again or try regular login`, {
          id: 'auth-error',
        });
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ??
          'There was an error authenticating. Please try again or try regular login',
        {
          id: 'auth-error-message',
        }
      );
    }
  };

  const getSignatureFromWeb3 = async (nonce, account) => {
    try {
      const web3 = new Web3(window.ethereum);
      const signature = await web3.eth.personal.sign(nonce, account);

      const data = {
        public_address: account,
        signature: signature,
      };

      const result = await apiSignInMetaMask(data);

      if (result.status === 'failed') {
        toast.error(result.message, {
          id: 'result-error-meta',
        });
      }

      if (result.data.success) {
        const apiResponse = result.data.data;
        const accessToken = apiResponse.access_token;

        tokenService.setAccessToken(accessToken);

        setCurrentUser(apiResponse.user);

        dispatch(setUser(apiResponse.user));

        navigate('/');
      }
    } catch (error) {
      toast.error(
        'Something went wrong fetching data from server. Please try again.',
        error.message,
        {
          id: 'error-signin',
        }
      );
    }
  };

  return (
    <React.Fragment>
      <div
        className="slds-col slds-size_1-of-1 slds-large-size_6-of-12"
        style={{
          display: 'flex',
          backgroundImage: 'linear-gradient(180deg, #367bd6 0%, #71adec 100%)',
        }}
      >
        <Toaster position="top-right" reverseOrder={false} />
        <div className="custom_slds_bkg_left">
          <div className="custom_slds_bkg_left_login">
            <div>
              <img
                style={{
                  display: 'block',
                  margin: 'auto',
                  height: '118px',
                  marginBottom: '30px',
                }}
                src={isDarkTheme ? QFG_login_white : QFG_login}
                alt="qfg_login"
              />
            </div>
            <form onSubmit={onFormSubmit}>
              {/* ---------------------------form--------------------------------- */}
              <div className="slds-form-element custom_slds_bkg_left_login_child">
                {/* --------------Email---------------------- */}
                <label className="slds-form-element__label" htmlFor="form-element-01">
                  Email
                </label>
                <div className="slds-form-element__control custom_slds-form-element__control slds-m-bottom_xx-small">
                  <input
                    type="email"
                    id="login_email"
                    placeholder="Email"
                    className="slds-input"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                {/* ---------------Password----------------------- */}
                <label className="slds-form-element__label" htmlFor="form-element-01">
                  Password
                </label>
                <div className="slds-form-element__control slds-m-bottom_small">
                  <input
                    type={passwordVisible ? 'text' : 'password'}
                    id="login_password"
                    placeholder="Password"
                    className="slds-input"
                    onChange={(e) => setPassword(e.target.value)}
                    style={{ paddingRight: '3.5rem' }}
                  />
                  <span
                    className="slds-input__icon slds-button slds-button_icon"
                    onClick={(e) => {
                      e.preventDefault();
                      setPasswordVisible(!passwordVisible);
                    }}
                    style={{ position: 'absolute', top: '20%', right: '10px' }}
                  >
                    {passwordVisible ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-eye"
                        viewBox="0 0 16 16"
                      >
                        {' '}
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />{' '}
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />{' '}
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-eye-slash"
                        viewBox="0 0 16 16"
                      >
                        {' '}
                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />{' '}
                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />{' '}
                        <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />{' '}
                      </svg>
                    )}
                  </span>
                </div>
                {/* ------------------Sign in Button--------------- */}
                <div className="slds-x-large-buttons_horizontal ">
                  <Button
                    style={{
                      width: '100%',
                      backgroundColor: '#0070D2',
                      color: '#fff',
                    }}
                    type="submit"
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        login({ email, password });
                      }
                    }}
                    disabled={loading}
                  >
                    {loading ? <>Loading..</> : <>Sign In</>}
                  </Button>
                </div>
                <div
                  style={{ marginTop: 15, marginBottom: 15 }}
                  className="sdls_global_text_center"
                >
                  or
                </div>
                <Button
                  style={{
                    width: '100%',
                    fontWeight: 500,
                    fontSize: 13,
                  }}
                  className="google-login"
                  onClick={() => loginWithGoogle(toast)}
                >
                  <img
                    src={Google_Icon}
                    style={{ width: '12px', marginRight: '7px' }}
                    alt="google_icon"
                  />
                  Sign in with Google
                </Button>
                <br />
                <Button
                  style={{
                    width: '100%',
                    fontWeight: 500,
                    fontSize: 13,
                    marginTop: '20px',
                  }}
                  className="google-login"
                  onClick={(e) => {
                    e.stopPropagation();
                    onSignInWithMetaMask(toast);
                  }}
                >
                  <img
                    src="/assets/icons/metamask-icon.png"
                    style={{ width: '12px', marginRight: '7px' }}
                    alt="metamask"
                  />
                  Sign in with MetaMask
                </Button>
                {/* -------------------Checkbox----------------------------- */}
                <div className="slds-col_padded slds-m-top_small" style={{ marginLeft: '-5px' }}>
                  <Checkbox
                    assistiveText={{
                      label: 'Default',
                    }}
                    id="checkbox-example"
                    labels={{
                      label: 'Remember me',
                    }}
                  />
                </div>
                <br />
                <Link to="/forgot-password" style={{ color: '#3A76CE', margin: 'auto 0px' }}>
                  Forgot Password?
                </Link>
              </div>
            </form>
            {/* <div className="custom_slds_bkg_left_forgot_pwd slds-m-top_small">
              <div
                style={{
                  color: '#2C3E64',
                  fontWeight: 700,
                  fontSize: 10,
                }}
              >
                Don't have an account?
              </div>
              <div style={{ marginLeft: 'auto', marginRight: '0px' }}>
                <Button
                  style={{
                    color: '#0070D2',
                    width: 129,
                    fontWeight: 600,
                  }}
                  className="sign-up-btn"
                >
                  Sign Up
                </Button>
              </div>
            </div> */}
            <div className="custom_slds_bkg_left_footer">
              {' '}
              <span>2022 Quant Ltd, All rights reserved</span>
              <div>
                <Link to="/privacy-and-policy" style={{ color: '#3A76CE', margin: 'auto 0px' }}>
                  Privacy & Policy
                </Link>{' '}
                |{' '}
                <Link to="/terms-and-conditions" style={{ color: '#3A76CE', margin: 'auto 0px' }}>
                  Terms and Conditions
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoginLeft;
